<script>
	import { Col, Row, Image } from "@sveltestrap/sveltestrap";
	import PageHeader from "../PageHeader/PageHeader.svelte";
	import { convert } from "../../services/helpers";
	import { navigate } from "svelte-routing";
	import { cachedTaskLookups } from "src/store/store";
	import CustomDropdown from "../CustomDropdown/CustomDropdown.svelte";

	export let detailData = {};
	export let toggle = () => {};
	export let vehicleStatus = 0;

	let taskLookups = $cachedTaskLookups;

	$: showLockUnlockButtons =
		detailData.vehicleStatusId !== 4 && detailData.vehicleStatusId !== 5;
</script>

<Row class="card-detail flex-grow-1" style="min-height:0">
	<Col xs={12}>
		{#if detailData.vehicleImages}
			<PageHeader
				title={detailData.vehicleMakeName +
					" " +
					detailData.vehicleModelName +
					" " +
					detailData.plateNumber}
			/>
		{:else}
			<PageHeader title="Car Details" />
		{/if}
	</Col>

	{#if detailData.vehicleImages}
		<Col xs={12}>
			<Image thumbnail src={detailData.vehicleImages[0]} alt="vehicle" />
		</Col>
	{/if}
	<Col>
		{#if !detailData.vehicleImages}
			<Row class="my-3">
				<Col>Vehicle</Col>
				<Col>
					<b>
						{detailData.vehicleMakeName}
						{detailData.vehicleModelName}
						{detailData.plateNumber}
					</b>
				</Col>
			</Row>
		{/if}
		<Row class={`d-flex align-items-center my-3`}>
			<Col><span>Status</span></Col>
			<Col>
				<CustomDropdown
					options={taskLookups?.vehicleStatuses}
					value={detailData.vehicleStatusId}
					isOpen={false}
					chevron={false}
					alignLeft
				/>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Active Start Date</span></Col>
			<Col>
				<b>{convert(detailData.activeFrom)}</b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Active End Date</span></Col>
			<Col>
				<b>{convert(detailData.activeTo)}</b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Enrollment Date</span></Col>
			<Col>
				<b>{convert(detailData.activeFrom)}</b>
			</Col>
		</Row>
		<Row class="card-detail-child ">
			<Col xs={12}>
				<PageHeader title="Car Location" />
			</Col>
			<Row>
				<Col xs={6}><span>Carpark ID</span></Col>
				<Col xs={6}>
					<p
						class="link"
						on:keyup={() => {}}
						on:click={() =>
							navigate(
								`/carpark-management/details/${detailData.carParkId}`
							)}
					>
						<span class="link link-text"
							><b>{detailData.carParkName}</b></span
						>
					</p>
				</Col>
			</Row>
			<Row>
				<Col xs={6}><span>Carpark Address</span></Col>
				<Col xs={6}>
					<b>{detailData.carParkAddress}</b>
				</Col>
			</Row>
			<Row>
				<Col xs={6}><span>Carpark Lot</span></Col>
				<Col xs={6}>
					{#if detailData.carParkLots.length > 0}
						<ul style="padding:0;margin:0;">
							{#each detailData.carParkLots as lot}
								<li style="list-style: none;">
									No: <b>{lot.lotNumber}</b>, Level:
									<b>{lot.level}</b>
								</li>
							{/each}
						</ul>
					{:else}
						<p>-</p>
					{/if}
				</Col>
			</Row>
		</Row>
		<Row class="card-detail-child my-3">
			<Col xs={12}>
				<PageHeader title="Fuel Card(s)" />
			</Col>
			<Row>
				<Col xs={6}><span>Fuel Card Number</span></Col>
				<Col xs={6}>
					<p>
						<span class="link link-text"
							>{#if detailData.fuelCards.length > 0}
								<ul style="padding:0;margin:0;">
									{#each detailData.fuelCards as fuelCard}
										<li
											style="list-style: none;"
											on:keyup={() => {}}
											on:click={() => {
												navigate(
													`/fuel-card-management/edit?id=${fuelCard.id}`
												);
											}}
										>
											<b>{fuelCard.cardNo}</b>
										</li>
									{/each}
								</ul>
							{:else}
								<p>-</p>
							{/if}</span
						>
					</p>
				</Col>
			</Row>
			<Row>
				<Col xs={6}><span>Company</span></Col>
			</Row>
			<Row>
				<Col xs={6}><span>Pin</span></Col>
				<Col xs={6}>
					{#if detailData.fuelCards.length > 0}
						<ul style="padding:0;margin:0;">
							{#each detailData.fuelCards as fuelCard}
								<li style="list-style: none;">
									<b>{fuelCard.pin}</b>
								</li>
							{/each}
						</ul>
					{:else}
						<p>-</p>
					{/if}
				</Col>
			</Row>
		</Row>
		{#if showLockUnlockButtons}
			<Row class="mb-3">
				<Col>
					<button
						type="button"
						class="link link-text"
						style="background:none;border:none;padding:0;cursor:pointer;font-weight:bold;"
						on:click={() => toggle("lock")}
					>
						Lock Vehicle
					</button>
				</Col>
			</Row>
			<Row class="mb-3">
				<Col>
					<button
						type="button"
						class="link link-text"
						style="background:none;border:none;padding:0;cursor:pointer;font-weight:bold;"
						on:click={() => toggle("unlock")}>Unlock Vehicle</button
					>
				</Col>
			</Row>
		{/if}
	</Col>
</Row>
